export const LINK_TAG_REGEX = /<\s*a[^>]*>(.*?)/;